module.exports = __webpack_public_path__ + "static/media/1. N25. Superficie sólida. 31 x 65 x 10 cm. 2021 copy.ca905096.png";